var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 21.375H11.7551L9.00513 7.625H36.505C36.7063 7.62574 36.9046 7.67057 37.0867 7.75637C37.2684 7.84214 37.4293 7.9668 37.5577 8.12151C37.6864 8.2762 37.7794 8.45723 37.8303 8.65177C37.8811 8.84633 37.8888 9.04967 37.8525 9.2475L35.5975 20.2475C35.545 20.5655 35.38 20.8542 35.1328 21.0611C34.8856 21.2679 34.5723 21.3793 34.25 21.375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00511 7.625L7.85011 3.225C7.78673 2.91443 7.61799 2.63529 7.37241 2.43484C7.12686 2.23439 6.81961 2.12493 6.50264 2.125H2.13013",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7551 21.375L12.9101 27.15C12.9735 27.4606 13.1423 27.7397 13.3878 27.9402C13.6334 28.1406 13.9407 28.25 14.2576 28.25H31.005",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6301 37.875C28.8709 37.875 28.2551 37.2593 28.2551 36.5C28.2551 35.7407 28.8709 35.125 29.6301 35.125C30.3897 35.125 31.0051 35.7407 31.0051 36.5C31.0051 37.2593 30.3897 37.875 29.6301 37.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8801 37.875C15.1207 37.875 14.5051 37.2593 14.5051 36.5C14.5051 35.7407 15.1207 35.125 15.8801 35.125C16.6395 35.125 17.2551 35.7407 17.2551 36.5C17.2551 37.2593 16.6395 37.875 15.8801 37.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/Retail.51089dbdf97a39f921b7d53c82a6db96.svg";
export { ForwardRef as ReactComponent };